/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { PremiumCalculatorMessage } from '../../../services/messages';
import Pricing, {
  FormatMoney,
  getAllInfoByISO,
} from '@vlinder-web/pricing-powerpuff-module-react';

import insuranceCalcConfig from '../../../config/insurance-calculator.config.json';

export const triggerParametroPlatformCharge = (lifeCycle: any) => {
  const message = lifeCycle?.fsm?.message as PremiumCalculatorMessage;
  // @ts-ignore
  const countryFound = insuranceCalcConfig[message.country];
  if (!countryFound) {
    throw Error(`unsupported country ${message.country} for this product`);
  }
  const pricing = Pricing.make({
    model: countryFound.platformCharge?.model,
    tiers: countryFound.platformCharge?.tiers,
  });
  const format = new FormatMoney({ decimals: 2 });
  const price = pricing.price(message.coverage);
  message.platformCharge = {
    raw: price,
    formatted: format.from(price, {
      symbol: getAllInfoByISO(message.country)?.symbol,
    }),
  };
  return true;
};
